const APPLICATION_MODE = {
  Development: "development",
  DevTools: "dev-tools",
  MarketingTools: "marketing-tools",
  Platform: "platform",
  Staging: "staging",
  Production: "production"
};
export {
  APPLICATION_MODE
};
//# sourceMappingURL=APPLICATION_MODE.js.map
